import SDIcon from './SDIcon'

const IconCustomCentury21 = (props) => (
  <SDIcon title='Century21' viewBox='0 0 540 682' {...props}>
    <path
    d='M289.61 432l63.04-91.1 1.46-2.1a93.064 93.064 0 1 0-170.22-52c0 1.2.03 2.3.07
    3.5h56.3c-.1-1.2-.16-2.3-.16-3.5a36.848 36.848 0 0 1 36.82-36.8c20.31 0 37.79 15.3
    36.83 36.8-.42 9.5-8.69 24.1-11.84 28.6-3.15 4.6-119.55 172.9-119.55
    172.9h159.18l38.92-56.3h-90.85zm143.86-238.3h-.62L393.93 250h48.9v238.3h56.2V193.7h-65.56zm17.94
    409.7a284.7 284.7 0 1 1 0-524.8 292.4 292.4 0 0 1 44.8 23.9l32.04-46.2A338.635 338.635 0 0 0 340.7
    0C152.53 0 0 152.7 0 341s152.53 341 340.7 341A338.7 338.7 0 0 0 535 621.1l-32.03-46.2a283.709
    283.709 0 0 1-51.56 28.5zm63.53-115.5a5.793 5.793 0 0 1-1.85-1l.65-1.2a7.1 7.1 0 0 0 1.64 1 6.231
    6.231 0 0 0 1.9.3 2.612 2.612 0 0 0 1.82-.5 1.59 1.59 0 0 0 .69-1.4 1.426 1.426 0 0 0-.36-1.1 1.486
    1.486 0 0 0-.82-.5 7.979 7.979 0 0 0-1.44-.4 8.555 8.555 0 0 1-2.29-.7 2.849 2.849 0 0 1-1.18-1
    2.372 2.372 0 0 1-.34-1.4 3.173 3.173 0 0 1 .6-2 3.274 3.274 0 0 1 1.52-1.1 6.2 6.2 0 0 1 1.94-.3
    6.132 6.132 0 0 1 3.5 1.1l-.62 1.1a5.233 5.233 0 0 0-2.93-.9 2.865 2.865 0 0 0-1.96.5 2.017 2.017
    0 0 0-.67 1.6 1.374 1.374 0 0 0 .23.8 1.194 1.194 0 0 0 .8.6 9.378 9.378 0 0 0 1.62.5c.71.1 1.31.3
    1.81.4a4.135 4.135 0 0 1 1.36.9 2.8 2.8 0 0 1 .61 1.8 3.005 3.005 0 0 1-.47 1.7 3.307 3.307 0 0
    1-1.33 1.2 6.1 6.1 0 0 1-2.03.4 9.876 9.876 0 0 1-2.4-.4zm19.22.2h-1.31v-9.4l-3.28
    8.2h-1.46l-3.26-8.2v9.4h-1.32v-11.3h1.94l3.38 8.4 3.35-8.4h1.96v11.3z'
    />
  </SDIcon>
)

export default IconCustomCentury21
